import { render } from "./CardList.vue?vue&type=template&id=51c666ce&scoped=true"
import script from "./CardList.vue?vue&type=script&lang=js"
export * from "./CardList.vue?vue&type=script&lang=js"

import "./CardList.vue?vue&type=style&index=0&id=51c666ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51c666ce"]])

export default __exports__